const HistoryHelper = {
  /**
   * Check if a booking item exists in local storage
   * @param {*} itemId
   * @returns
   */
  _isBookingItem: function (itemId) {
    if (typeof localStorage !== "undefined") {
      let bookingItems = localStorage.getItem("bookingItems")
        ? JSON.parse(localStorage.getItem("bookingItems"))
        : [];
      let previousBooking = false;
      bookingItems.forEach(function (item) {
        if (itemId == item.id) {
          previousBooking = item;
          return item.date;
        }
      });
      return previousBooking;
    }
    return false;
  },

  saveVisitedItem: function (itemId) {
    if (typeof localStorage !== "undefined") {
      let historyItems = localStorage.getItem("historyItems")
        ? JSON.parse(localStorage.getItem("historyItems"))
        : [];
      historyItems.forEach(function (item) {
        if (item.id == itemId) {
          historyItems = historyItems.filter((item) => item.id !== itemId);
        }
      });
      historyItems.push({ id: itemId, date: new Date().getTime() });
      localStorage.setItem("historyItems", JSON.stringify(historyItems));
    }
  },

  setBookingItemInfo: function (wrapperId = "booking-history") {
    const bhWrap = document.getElementById(wrapperId);
    if (bhWrap) {
      const booked = this._isBookingItem(bhWrap.getAttribute("data-id"));
      if (booked) {
        bhWrap.innerHTML = global.Translator.trans(
          "booking.history",
          { date: new Date(booked.date).toLocaleString() },
          "js"
        );
        bhWrap.hidden = false;
        return true;
      }
    }
    return false;
  },
};

export default HistoryHelper;
